import React from 'react';

import Card from '../../../../components/Card';
import ArticleMetadata from '../../../../components/ArticleMetadata';

import './style.scss';

interface NodeArticleCardProps {
  title: string;
  subtitle?: string;
  image: React.ReactNode;
  link: string;
  themes?: string[];
  publicationDate: number;
  type: string;
  langcode: 'nl' | 'en';
}

const NodeArticleCard: React.FC<NodeArticleCardProps> = ({
  title,
  subtitle,
  image,
  link,
  themes = [],
  publicationDate,
  type,
  langcode,
}) => (
  <Card className="NodeArticleCard" {...link && { withLink: true }}>
    <Card.Content>
      <Card.Image
        image={image}
      />

      <div className="Card__content__text">
        <Card.Link href={link}>
          <Card.Title title={title} />
        </Card.Link>

        {subtitle && (
          <Card.Subtitle
            subtitle={(
              <p className="u-truncate--3 body--small">
                {subtitle}
              </p>
            )}
          />
        )}

        <div className="Card__content__metadata">
          <ArticleMetadata>
            {(themes.length > 0) && (
              <ArticleMetadata.Themes themesNames={themes} />
            )}
            <ArticleMetadata.Type type={type} />
            <ArticleMetadata.PublicationDate
              publicationDate={new Date(publicationDate)}
              langcode={langcode}
            />
          </ArticleMetadata>
        </div>
      </div>
    </Card.Content>
  </Card>
);

export default NodeArticleCard;
